import { Block, Card, Text } from '@rulebooks/evidend-titan';
import { Trans } from '@lingui/macro';
import type { SummaryCardsComponentProps } from 'helpers/formatMutation';
import React from 'react';
import { DeedCard } from 'summaries/DeedCard/DeedCard';

export const LiquidationSummaryCards = ({
  backgroundVariant = 'white',
  mutation,
  onDocumentSave,
}: SummaryCardsComponentProps) => {
  const reason = mutation.liquidation?.reason;

  return (
    <>
      {!!reason && (
        <>
          <Text color="grey80" spaceAfter={6} type="labelBold">
            <Trans>Reden voor beëindiging</Trans>
          </Text>

          <Card spaceAfter={6}>
            <Block>{reason}</Block>
          </Card>
        </>
      )}

      {mutation.document && (
        <Block spaceAfter={10}>
          <DeedCard
            backgroundVariant={backgroundVariant}
            document={mutation.document}
            mutation={mutation}
            onDocumentSave={onDocumentSave}
          />
        </Block>
      )}
    </>
  );
};
